import { render, staticRenderFns } from "./Section15.vue?vue&type=template&id=3bca32c9&"
import script from "./Section15.vue?vue&type=script&lang=js&"
export * from "./Section15.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports